/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfNavigationItemDto } from '../../models/platform-api-result-of-navigation-item-dto';
import { PlatformChangeNavigationItemName } from '../../models/platform-change-navigation-item-name';

export interface PostNavigationitemsActionChangename$Params {
      body: PlatformChangeNavigationItemName
}

export function postNavigationitemsActionChangename(http: HttpClient, rootUrl: string, params: PostNavigationitemsActionChangename$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfNavigationItemDto>> {
  const rb = new RequestBuilder(rootUrl, postNavigationitemsActionChangename.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfNavigationItemDto>;
    })
  );
}

postNavigationitemsActionChangename.PATH = '/api/navigationitems/action/changename';
